module.exports = __webpack_public_path__ + "static/3_1-c0a3c1f3c9af67e8379bad68b2c31cda.jpg";